import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: { xs: 4, sm: 6 },
        textAlign: 'center',
      }}
    >
      <Box sx={{ width: '100%' }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
          Created by Rios & Aquíferos, Lda. / Water2you, Lda.
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          <Link color="text.secondary" href="/licenses" sx={{ textDecoration: 'none', '&:hover': {color: 'primary.main'}, }}>
            Used open-source software and libraries
          </Link>
        </Typography>
      </Box>
    </Container>
  );
}
